import { render } from "./ProfitLoss.vue?vue&type=template&id=1b2bb2d4&scoped=true"
import script from "./ProfitLoss.vue?vue&type=script&lang=js"
export * from "./ProfitLoss.vue?vue&type=script&lang=js"

import "./ProfitLoss.vue?vue&type=style&index=0&id=1b2bb2d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b2bb2d4"]])

export default __exports__